import ky from 'ky';
import { useUserMessageStore } from '../stores';
import { findMessage } from '../utils/userMessages';

const baseUrl = `${window.location.protocol}//${window.location.hostname}/api`;

interface ItemWithMessage {
  message: string;
}

export const api = ky.create({
  prefixUrl: baseUrl,
  timeout: 60000,
  hooks: {
    beforeRequest: [
      async () => {
        useUserMessageStore.getState().setApiCallStarted();
      },
    ],
    afterResponse: [
      async () => {
        useUserMessageStore.getState().setApiCallCompleted();
      },
    ],
    beforeError: [
      async (error) => {
        const { response } = error;
        if (response.status == 401 || response.status == 403) {
          try {
            const body = (await error.response.json()) as ItemWithMessage;
            const readableMessage = findMessage(body?.message);
            useUserMessageStore.getState().setUserMessage(readableMessage, 'error');
          } finally {
            window.location.href = '/auth/sign-in';
          }
        } else if (response.status == 404) {
          try {
            const body = (await error.response.json()) as ItemWithMessage;
            if (body?.message === 'Domain_NotFound') {
              window.location.href = '/error/domain-not-found';
            } else {
              const readableMessage = findMessage(body?.message);
              useUserMessageStore.getState().setUserMessage(readableMessage || body.message || error.message, 'error');
            }
          } catch {
            useUserMessageStore.getState().setUserMessage(findMessage('Unhandled_Error'), 'error');
          }
        } else if (response.status == 400 || response.status == 409) {
          try {
            const body = (await error.response.json()) as ItemWithMessage;
            const readableMessage = findMessage(body?.message);
            useUserMessageStore.getState().setUserMessage(readableMessage || body.message || error.message, 'error');
          } catch {
            useUserMessageStore.getState().setUserMessage(findMessage('Unhandled_Error'), 'error');
          }
        } else if (response.status > 500) {
          useUserMessageStore.getState().setUserMessage('An unexpected error occurred. Please try again.', 'error');
        }
        return error;
      },
    ],
  },
});
